import { Component, OnInit, Renderer2, Inject } from '@angular/core';

@Component({
  selector: 'app-forbidden',
  templateUrl: './forbidden.component.html',
  styleUrls: ['../error.component.scss']
})
export class forbiddenComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {

  }
}
